export default __webpack_public_path__ + "e344696f9b8de5886d3f6276d5f94bfd.mp4";